'use client'

import Script from 'next/script'

import { configPublic } from '@src/config.public'

const SITE_KEY = configPublic.googleRecaptcha.siteKey

export function Recaptcha() {
  return (
    <Script
      strategy="afterInteractive"
      src={`https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`}
    />
  )
}
